import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "staff-row-menu" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "staff-row-menu__dropdown-option-text" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { i18n } from '@/i18n';

/** Emits */

export default /*@__PURE__*/_defineComponent({
  __name: 'StaffFilterRowMenu',
  emits: ["onSelectMenu"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const menuButtonPosition = ref({
  x: 0,
  y: 0,
});

/** Menu items */
const MENU_ITEMS = [
  {
    value: 'download' as const,
    icon: 'downloadSmall',
    text: 'ダウンロード',
  },
];

/**
 * 三点ボタンをクリックした時の処理
 */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    if (!(buttonContent instanceof HTMLElement)) return;
    const rect = buttonContent.getBoundingClientRect();
    menuButtonPosition.value = {
      x: window.innerWidth - rect.right,
      y: rect.bottom,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const dropdownMenuStyle = computed((): StyleValue => {
  return {
    top: `${menuButtonPosition.value.y}px`,
    right: `${menuButtonPosition.value.x}px`,
  };
});

/**
 * メニューの選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('onSelectMenu', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        id: _unref(containerId),
        class: "staff-row-menu__ellipsis-container"
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["staff-row-menu__ellipsis-button", { 'staff-row-menu__ellipsis-button--active': isMenuOpenedState.value }]),
          onClick: onClickButton
        }, [
          _createVNode(SvgLoader, {
            class: "staff-row-menu__ellipsis-icon",
            name: "menuEllipsis"
          })
        ], 2)
      ], 8, _hoisted_2)
    ]),
    (isMenuOpenedState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "staff-row-menu__bg",
            onClick: onClickButton
          }),
          _createElementVNode("div", {
            class: "staff-row-menu__dropdown",
            style: _normalizeStyle(dropdownMenuStyle.value)
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(MENU_ITEMS, (option) => {
              return _createElementVNode("div", {
                key: option.value,
                class: "staff-row-menu__dropdown-content"
              }, [
                _createElementVNode("button", {
                  class: "staff-row-menu__dropdown-option staff-row-menu__dropdown-option--active",
                  onClick: ($event: any) => (selectOption(option.value))
                }, [
                  _createVNode(SvgLoader, {
                    class: "staff-row-menu__dropdown-icon",
                    name: option.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(option.text)), 1)
                ], 8, _hoisted_3)
              ])
            }), 64))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})